// extracted by mini-css-extract-plugin
export default {"header":"header--TCnfQ","header__left":"header__left--SBu5T","header__right":"header__right--hOQlJ"};